export interface MerchantRouteMetadata {
  id: string;
  navId: string;
  title: string;
}

export const merchantRouteMetadata: MerchantRouteMetadata[] = [
  route("onboarding", "dashboard", "Set up Price Rescue"),
  route("support-feedback", "support-feedback", "Support & Feedback"),
  route("faq", "faq", "FAQ"),
  route("dashboard", "dashboard", "Dashboard"),
  route("notification-center", "dashboard", "Notifications"),
  route("requests-list", "requests", "Price-match requests"),
  route("request-detail-review", "requests", "Request review"),
  route("notification-delivery-failure", "requests", "Notification delivery failure"),
  route("products-list", "products", "Products and catalog"),
  route("product-detail", "products", "Product detail"),
  route("bulk-product-action", "products", "Bulk product action"),
  route("bulk-partial-results", "products", "Bulk action results"),
  route("deleted-product-historical", "products", "Deleted product history"),
  route("competitors-list", "competitors", "Competitor domains"),
  route("competitor-detail", "competitors", "Competitor detail"),
  route("add-competitor", "competitors", "Add competitor"),
  route("competitors-empty", "competitors", "No competitors"),
  route("mappings", "mappings", "Product mappings"),
  route("pricing-policies", "policies", "Pricing policies"),
  route("monitoring", "monitoring", "Monitoring"),
  route("analytics-overview", "reports", "Analytics"),
  route("team-access", "team", "Team access"),
  route("assign-user-role", "team", "Assign user role"),
  route("settings", "settings", "Settings"),
  route("plans-pricing", "plans-pricing", "Plans & Pricing"),
  route("audit-history", "audit", "Audit history"),
  route("access-pending", "dashboard", "Access pending"),
  route("platform-reauthorization", "dashboard", "Platform reauthorization"),
];

function route(id: string, navId: string, title: string): MerchantRouteMetadata {
  return { id, navId, title };
}
